import urlApi from './urlApi';
export var GET_COUNTRY_INNER_PAGE_REQUEST = 'GET_COUNTRY_INNER_PAGE_REQUEST';
export var GET_COUNTRY_INNER_PAGE_SUCCESS = 'GET_COUNTRY_INNER_PAGE_SUCCESS';
export var GET_COUNTRY_INNER_PAGE_ERROR = 'GET_COUNTRY_INNER_PAGE_ERROR';
export function getCountryInnerPage(id) {
    return function (dispatch) {
        dispatch({
            type: GET_COUNTRY_INNER_PAGE_REQUEST,
        });
        urlApi().getCountryInnerPage(id).then(function (res) {
            dispatch({
                type: GET_COUNTRY_INNER_PAGE_SUCCESS,
                payload: res,
            });
        });
    };
}
//# sourceMappingURL=getCountryInnerPage.js.mapimport urlApi from './urlApi';
export var GET_COUNTRY_INNER_PAGE_REQUEST = 'GET_COUNTRY_INNER_PAGE_REQUEST';
export var GET_COUNTRY_INNER_PAGE_SUCCESS = 'GET_COUNTRY_INNER_PAGE_SUCCESS';
export var GET_COUNTRY_INNER_PAGE_ERROR = 'GET_COUNTRY_INNER_PAGE_ERROR';
export function getCountryInnerPage(id) {
    return function (dispatch) {
        dispatch({
            type: GET_COUNTRY_INNER_PAGE_REQUEST,
        });
        urlApi().getCountryInnerPage(id).then(function (res) {
            dispatch({
                type: GET_COUNTRY_INNER_PAGE_SUCCESS,
                payload: res,
            });
        });
    };
}
//# sourceMappingURL=getCountryInnerPage.js.map